import React, { memo, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  showModal,
  saveInProgress,
  checkRdopCont,
  setMenuInfo,
} from '@store/actions/commonAction';
import * as customerAction from '@store/actions/customerAction';
import * as planAction from '@store/actions/planAction';
import * as registerAction from '@store/actions/registerAction';
import * as appListAction from '@store/actions/appListAction';
import { getToday, addDates } from '@common/utils/date';
import { changeSearchParam } from '@store/actions/planListAction';
import { saveAppViewSearchParams } from '@store/actions/appViewAction';
import InstallPopup from '@components/common/InstallPopup';
import { PRODUCT_COMP_CD } from '@common/constants';
import StopPlanPop from '@components/common/StopPlanPop';
import { PC_LAS_MENU_ID } from '@common/hooks/route/menu';
// import firebase from 'firebase/app';

const SnbMenuItemButton = ({ depth, menu, isTreeOpen, toggleTree }) => {
  const dispatch = useDispatch();

  const { sendMenuOpen, getMainLinkToken, getPCToken } = $hooks.useApi();
  const { navigate, location, checkParentMenu } = $hooks.useRoute();
  const { error: toastError } = $hooks.useToast();
  const { inProgress = [] } = useSelector(state => state.commonReducer);
  const { searchParam } = useSelector(state => state.planListReducer);
  const { customerInfo, originCustomerInfo } = useSelector(
    state => state.customerReducer,
  );
  const { compCd } = useSelector(state => state.planReducer);
  const { pathname } = location;
  const [showInstallPop, setShowInstallPop] = useState(false);

  useEffect(() => {
    if (pathname === '/home/main' && menu.menuId === 'SFA_T_10000000') {
      dispatch(setMenuInfo(menu));
    }
  }, []);

  const handleMoveToPc = async url => {
    try {
      const response = await getPCToken();
      const isSuccess = $utils.checkApiSuccess(response);
      if (!isSuccess) {
        const message = $utils.getApiErrorMessage(
          response,
          '토큰 정보를 가져오는데 실패하였습니다.',
        );
        throw message;
      }

      const data = $utils.getApiData(response);
      const { token } = data;
      const pcLinkUrl = $utils.addUrlQueries(url, { token });

      // PC 메뉴는 외부 브라우저로 띄울 시 download 페이지로 Redirect 되므로 inLink로 노출
      $utils.openUrl(pcLinkUrl, 'inLink');
    } catch (error) {
      console.log('handleMoveToPc() - error', error);

      const message =
        typeof error === 'string'
          ? error
          : '메뉴 이동 중 에러가 발생하였습니다.';
      toastError(message);

      throw error;
    }
  };

  const handleClickMenu = async menuInfo => {
    const isChildren = menuInfo?.items?.length > 0;
    if (isChildren) toggleTree();
    else {
      const { menuId, linkMenuYn, linkUrlAddr, ssoLinkdYn, path } = menuInfo;

      const isPCLAS = menuId === PC_LAS_MENU_ID;
      const isLinkMenu = linkMenuYn?.toUpperCase() === 'Y';

      // PC LAS 메뉴인 경우
      if (isPCLAS) {
        handleMoveToPc(linkUrlAddr);
      }

      // 링크 메뉴인 경우
      else if (isLinkMenu) {
        let ssoToken = '';
        const isSsoLink = ssoLinkdYn === 'Y';
        if (isSsoLink) {
          ssoToken = await $utils.getLinkToken(getMainLinkToken);
          if (!ssoToken)
            return toastError('링크 정보를 가져오는데 실패하였습니다.');
        }

        const linkUrl = $utils.makeLinkMenuUrl(linkUrlAddr, ssoToken);

        // Snb의 모든 링크 outLink로 변경
        $utils.openUrl(linkUrl, 'outLink');
      }

      // 일반 메뉴인 경우
      else {
        checkMoveRoute(path || linkUrlAddr);
      }

      /* 메뉴 사용 현황 API 전송 */
      if (menuInfo.menuId) {
        sendMenuOpen({ menuId: menuInfo.menuId });
        if (menuInfo.childYn === 'N') {
          dispatch(setMenuInfo(menuInfo));
        }
      }
    }
  };

  const checkMoveRoute = async path => {
    // console.log(path);
    // firebase
    //   .analytics()
    //   .logEvent('select_content', { content_type: 'handleLnb' });

    //상벌점으로 패털티 있을때 가입설계 및 설계목록 못들어가게 막기
    // if (path === '/plan' || path === '/planList') {
    //   if (checkRdopCntList.length > 0) {
    //     setShowStopPop(true);
    //   }
    // }

    if (pathname === '/home/customerInfo') {
      /* @NOTE: 홈 이동 시 초기화 되지 않는게 맞다고 하여 수정 */
      // dispatch(customerAction.initCustomerInfo());

      if (path === '/home' || path === '/home/main') {
        if (inProgress.includes('/home')) {
          showMoveMenuModal(
            '수정중인 고객정보가 저장되지 않았습니다. 그래도 이동하시겠어요?',
            () => {
              dispatch(customerAction.updateCustomerInfo(originCustomerInfo));
              dispatch(
                saveInProgress(inProgress.filter(item => item !== '/home')),
              );

              dispatch(customerAction.initCustomerInfo());
              navigate(path);
            },
          );
        } else if (originCustomerInfo) {
          showMoveMenuModal(
            `${originCustomerInfo.name}님의 업무를 진행중입니다. 업무를 종료하시겠어요?`,
            () => {
              dispatch(customerAction.initCustomerInfo());
              navigate(path);
            },
          );
        } else {
          navigate(path);
        }
      } else {
        navigate(path);
      }
    } else if (path === '/planList') {
      //목록 조회 누를떄 검색값 초기화
      dispatch(
        changeSearchParam({
          ...searchParam,
          searchStartDate: $utils.getPlanListSearchDates('list', 'start'),
          searchEndDate: $utils.getPlanListSearchDates('list', 'end'),
          delType: 'N',
          favoriteType: 'ALL',
          excuteFinancial: 'ALL',
          compCd: 'ALL',
          pageIndex: '1',
          searchName: '',
        }),
      );
      navigate(path);
    } else if (
      //path === '/plan' &&
      inProgress.includes('/plan') &&
      pathname === '/plan' &&
      compCd === PRODUCT_COMP_CD.kb //TODO KB일때만 초기화
      //pathname.includes('/planMain')
    ) {
      showMoveMenuModal('작업 하시던 가입설계 내용이 초기화 됩니다.', () => {
        dispatch(planAction.initPlanState());
        dispatch(saveInProgress(inProgress.filter(item => item !== '/plan')));
        navigate(path);
      });
    } else if (
      path === '/register' &&
      inProgress.includes('/register') &&
      pathname.includes('/register')
    ) {
      showMoveMenuModal('작업 하시던 가입설계 내용이 초기화 됩니다.', () => {
        dispatch(registerAction.initialState());
        dispatch(
          saveInProgress(inProgress.filter(item => item !== '/register')),
        );
        navigate(path);
      });
    } else if (path === '/appList') {
      dispatch(
        appListAction.saveSearchParms({
          searchStartDate: addDates(getToday(), 'months', -1, 'yyyyMMdd'),
          searchEndDate: getToday('yyyyMMdd'),
          searchState: 'ALL',
          pageIndex: '1',
          custNo: '',
          searchName: '',
          pageConditionKey: '',
          pageCount: 10,
          pageNextYn: '',
        }),
      );
      navigate(path);
    } else if (path === '/lips') {
      const token = await $utils.getLinkToken(getMainLinkToken);
      const lipsUrl = $utils.getLipsLink(token, customerInfo);

      // hanjy: 링크 유효성 검증
      if (!lipsUrl) {
        dispatch(
          showModal({
            visible: true,
            msg: '고객정보 동기화 중입니다. 잠시 후 다시 시도해주세요.',
          }),
        );
        return;
      }

      $utils.openUrl(lipsUrl);
    } else if (path === '/appView') {
      dispatch(
        saveAppViewSearchParams({
          searchStartDate: addDates(getToday(), 'months', -2, 'yyyyMMdd'),
          searchEndDate: getToday('yyyyMMdd'),
          searchState: '',
          searchText: '',
          mode: '',
          eappReadStatCd: '',
          pageIndex: '1',
          pageCount: 10,
          pageConditionKey: '',
          pageNextYn: '',
        }),
      );
      navigate(path);
    } else if (path === '/installPop') {
      // 설치팝업 호출
      setShowInstallPop(true);
    } else {
      navigate(path);
    }
  };

  const showMoveMenuModal = (
    msg = '',
    handleOk = () => {},
    handleCancel = () => {},
  ) => {
    dispatch(
      showModal({
        visible: true,
        type: 'confirm',
        msg,
        onOk: { label: '예', handle: () => handleOk() },
        onCancel: { label: '아니요', handle: () => handleCancel() },
      }),
    );
  };

  /* 현재 메뉴의 Active(활성화) 여부 [현재 화면이 해당 path 인지 확인] */
  const isActive = pathname === menu.path;

  return (
    <>
      {depth === 1 ? (
        <button
          className={$classNames('btn-lnb', {
            active: isTreeOpen || checkParentMenu(menu, depth),
          })}
          type="button"
          onClick={() => handleClickMenu(menu)}
        >
          <span className={$classNames('ico ico-gnb', menu?.icon)}></span>
          <strong className="tit">{menu.label}</strong>
        </button>
      ) : (
        <button
          className={$classNames({ active: isActive || isTreeOpen })}
          type="button"
          onClick={() => handleClickMenu(menu)}
        >
          {menu.label}
        </button>
      )}
      {showInstallPop && (
        <InstallPopup
          showInstallPop={showInstallPop}
          isShowCheckList={false}
          onShowPopup={() => setShowInstallPop(true)}
          onHidePopup={() => setShowInstallPop(false)}
        />
      )}
    </>
  );
};

SnbMenuItemButton.propTypes = {
  depth: $propTypes.number,
  menu: $propTypes.object.isRequired,
  isTreeOpen: $propTypes.bool,
  toggleTree: $propTypes.func,
};

SnbMenuItemButton.defaultProps = {
  depth: 1,
  toggleTree: () => {},
};

export default memo(SnbMenuItemButton);
